import { EIV_STATUS_TO_SHOW, TENANT_ID } from 'global/constants';

import { isProduction } from 'utils/StageUtils';
import { getTenantId } from 'utils/tenantUtil';

export const isSubAccountEnabled = () => {
  if (!isProduction()) return true;

  const isEnabledForTenant = {
    [TENANT_ID.EDI]: false,
    [TENANT_ID.SHNG]: false,
    [TENANT_ID.AVA]: false,
    [TENANT_ID.BAG]: false,
    [TENANT_ID.LVN]: false,
    [TENANT_ID.MTN]: true,
  };
  return isEnabledForTenant[getTenantId()];
};

export const filterExpertForTable = (expert, hasEnergy, hasGas) => {
  const showEnergy = EIV_STATUS_TO_SHOW.includes(expert.statusStrom ?? expert.statusEnergy);
  const showGas = EIV_STATUS_TO_SHOW.includes(expert.statusGas);

  if (showEnergy && !showGas) {
    return hasEnergy;
  }

  if (!showEnergy && showGas) {
    return hasGas;
  }

  if (showEnergy && showGas) {
    return hasEnergy || hasGas;
  }

  return false;
};
